import axios from "axios";

export default {
  getFeed: function (
    baseApiUrl,
    rssUrl,
    visaBaraAr,
    sorteraPaPubdatumOchTitel,
    take
  ) {
    let lang = document.documentElement.lang;
    var response = axios.post(
      baseApiUrl +
        "/Rss?url=" +
        rssUrl +
        "&lang=" +
        lang +
        "&visaBaraAr=" +
        visaBaraAr +
        "&sorteraPaPubdatumOchTitel=" +
        sorteraPaPubdatumOchTitel +
        "&take=" +
        take
    );
    return response;
  },
};
